module.exports = __webpack_public_path__ + "static/media/loader.2e2c14cf.gif";